var map = {
	"./head-bj.png": "ffde",
	"./head1-en.png": "eb4d",
	"./head1-zh.png": "fbe9",
	"./head2-en.png": "53d7",
	"./head2-zh.png": "c793",
	"./head3-en.png": "4d53",
	"./head3-zh.png": "847d",
	"./head4-en.png": "3ab2",
	"./head4-zh.png": "d2eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ef3";